import { render, staticRenderFns } from "./lottie-animation.vue?vue&type=template&id=d56cdf2e&scoped=true&lang=pug"
import script from "./lottie-animation.vue?vue&type=script&lang=js"
export * from "./lottie-animation.vue?vue&type=script&lang=js"
import style0 from "./lottie-animation.vue?vue&type=style&index=0&id=d56cdf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56cdf2e",
  null
  
)

export default component.exports